import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api/axios';
import Swal from 'sweetalert2';
import { FaUser, FaEnvelope, FaLock, FaUserPlus } from 'react-icons/fa';

export default function Register() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: '',
        password_confirmation: ''
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await api.post('/register', formData);
            localStorage.setItem('token', response.data.token);
            
            Swal.fire({
                icon: 'success',
                title: 'Account Created!',
                text: 'Welcome to TicketFlow.',
                showConfirmButton: false,
                timer: 1500
            });

            setTimeout(() => {
                navigate('/');
                window.location.reload();
            }, 1500);

        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Registration Failed',
                text: error.response?.data?.message || 'Please check your inputs and try again.'
            });
        }
    };

    return (
        <div className="container mt-5 fade-in-up">
            <div className="row justify-content-center">
                <div className="col-md-5">
                    <div className="card event-card border-0 p-4">
                        <div className="card-body">
                            <div className="text-center mb-4">
                                <h3 className="fw-bold text-dark">Join TicketFlow 🚀</h3>
                                <p className="text-muted">Create an account to book events</p>
                            </div>

                            <form onSubmit={handleSubmit}>
                                <div className="mb-3 text-start">
                                    <label className="form-label fw-bold text-secondary">Full Name</label>
                                    <div className="input-group shadow-sm">
                                        <span className="input-group-text bg-white border-end-0"><FaUser className="text-muted" /></span>
                                        <input type="text" name="name" className="form-control border-start-0 ps-0" placeholder="John Doe" onChange={handleChange} required />
                                    </div>
                                </div>
                                <div className="mb-3 text-start">
                                    <label className="form-label fw-bold text-secondary">Email Address</label>
                                    <div className="input-group shadow-sm">
                                        <span className="input-group-text bg-white border-end-0"><FaEnvelope className="text-muted" /></span>
                                        <input type="email" name="email" className="form-control border-start-0 ps-0" placeholder="john@example.com" onChange={handleChange} required />
                                    </div>
                                </div>
                                <div className="mb-3 text-start">
                                    <label className="form-label fw-bold text-secondary">Password</label>
                                    <div className="input-group shadow-sm">
                                        <span className="input-group-text bg-white border-end-0"><FaLock className="text-muted" /></span>
                                        <input type="password" name="password" className="form-control border-start-0 ps-0" placeholder="Create a strong password" onChange={handleChange} required />
                                    </div>
                                </div>
                                <div className="mb-4 text-start">
                                    <label className="form-label fw-bold text-secondary">Confirm Password</label>
                                    <div className="input-group shadow-sm">
                                        <span className="input-group-text bg-white border-end-0"><FaLock className="text-muted" /></span>
                                        <input type="password" name="password_confirmation" className="form-control border-start-0 ps-0" placeholder="Repeat your password" onChange={handleChange} required />
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-gradient w-100 rounded-pill d-flex align-items-center justify-content-center shadow-sm">
                                    <FaUserPlus className="me-2" /> Create Account
                                </button>
                            </form>

                            <div className="text-center mt-4">
                                <p className="text-muted mb-0">Already have an account? <Link to="/login" className="text-primary fw-bold text-decoration-none">Login here</Link></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}